import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import Layout from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <Layout>
      <div className="section-padding min-h-[80vh] flex items-center justify-center bg-background relative overflow-hidden">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-accent/5 blur-[120px] z-0" />

        <div className="text-center max-w-xl relative z-10 p-12 bg-white/40 backdrop-blur-xl rounded-[3rem] border border-white/60 shadow-premium">
          <div className="text-[12rem] font-black text-primary/5 uppercase tracking-tighter leading-none mb-4 select-none">404</div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full">
            <h1 className="text-4xl font-black text-primary uppercase tracking-tighter mb-4">Route <span className="text-gradient-gold">Defunct</span></h1>
            <p className="text-muted-foreground font-medium mb-12 max-w-xs mx-auto leading-relaxed">
              The requested coordinate is currently outside our operational perimeter.
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <Link to="/">
                <Button className="btn-gold h-14 px-10 text-[10px] font-black uppercase tracking-widest shadow-premium">
                  <Home className="w-4 h-4 mr-2" />
                  Terminal Home
                </Button>
              </Link>
              <Button
                className="h-14 px-10 text-[10px] font-black uppercase tracking-widest bg-white/50 border-white/80 hover:bg-white transition-all shadow-sm"
                onClick={() => window.history.back()}
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Previous Coordinate
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
